import { lazy, Suspense } from 'react'
import UberEatsBanner from '../uberEats/UberEatsBanner'
import UberEatsHelp from '../uberEats/UberEatsHelp'

const ShuttleAppreciation = lazy(() => import('../../shuttle_software/ShuttleAppreciation'));
const TaxiFaq = lazy(() => import('../../taxiDispatchSoftware/TaxiFaq'));
const GroceryMarket = lazy(() => import('../groceryApp/GroceryMarket'));
const UberEatsAdvance = lazy(() => import('../uberEats/UberEatsAdvance'));
const UberEatsBenifits = lazy(() => import('../uberEats/UberEatsBenifits'));
const UberEatsDemand = lazy(() => import('../uberEats/UberEatsDemand'));
const UberEatsLove = lazy(() => import('../uberEats/UberEatsLove'));
const UberEatsOffer = lazy(() => import('../uberEats/UberEatsOffer'));
const UberEatsPower = lazy(() => import('../uberEats/UberEatsPower'));
const UberEatsProcess = lazy(() => import('../uberEats/UberEatsProcess'));
const UberEatsRevenue = lazy(() => import('../uberEats/UberEatsRevenue'));
const UberEatsScript = lazy(() => import('../uberEats/UberEatsScript'));
const UberEatsSteps = lazy(() => import('../uberEats/UberEatsSteps'));
const UberEatsUnique = lazy(() => import('../uberEats/UberEatsUnique'));

const bannerData = {
  heading: "Doordash Clone App AI-powered",
  desc: "Our AI-powered DoorDash Clone App delivers a seamless, quick, and tailored food ordering experience—connecting restaurants and customers across the USA with efficiency and precision.",
  cta: "Get free demo",
  image: "/assets/home/uber-eats-banner.webp",
  breadcrumbData: {
    newClass: "white-breadcrumb",
    list: [
      {
        page: "Home",
        slug: "/"
      },
      {
        page: "Doordash Clone App",
        slug: ""
      },
    ]
  }
}

const helpData = {
  headingPart1: "What Is an",
  headingPart2: "Doordash Clone",
  headingPart3: "& How Does It Help?",
  desc: [
    "A DoorDash clone is a pre-built food delivery solution that replicates the core features and workflow of the DoorDash platform. It comes ready with user-friendly ordering apps, restaurant dashboards, delivery driver tools, and a powerful admin panel. Fully customizable, the clone can be branded, scaled, and adapted to suit U.S. market needs—cutting down development time and costs dramatically.",

    "This solution empowers entrepreneurs and startups in the U.S. food delivery industry to launch their platforms quickly without the hurdles of building from scratch. With Mobility Infotech’s DoorDash clone, businesses can go live in just days, focusing on customer acquisition, partnerships, and growth rather than lengthy development cycles."
  ]
}

const processData = {
  headingPart1: "How",
  headingPart2: "AI-Fueled DoorDash",
  headingPart3: "like app Streamlines the Process?",
  subHeading: "An AI-powered DoorDash-like app from Mobility Infotech optimizes operations end-to-end: automating orders, minimizing delivery delays, optimizing routes, and elevating customer satisfaction with data-backed decision-making.",
  boxes: [
    {
      image1: "/assets/home/uber-eats-process-1.webp",
      image2: "/assets/home/uber-eats-process-hover-1.webp",
      head: "AI Personalisation Engine",
      desc: "Using machine learning and NLP, the personalization engine identifies customer preferences, predicts repeat choices, and recommends meals. This creates a highly individualized ordering journey, strengthening engagement and loyalty.",
    },
    {
      image1: "/assets/home/uber-eats-process-2.webp",
      image2: "/assets/home/uber-eats-process-hover-2.webp",
      head: "AI-Aided Virtual Assistant",
      desc: "The built-in Artificial Intelligence assistant answers customer queries instantly, tracks orders, and resolves issues proactively. By reducing repetitive manual tasks, it ensures smooth, fast, and more responsive customer service.",
    },
    {
      image1: "/assets/home/uber-eats-process-3.webp",
      image2: "/assets/home/uber-eats-process-hover-3.webp",
      head: "AI-Centric Dynamic Pricing",
      desc: "With intelligent algorithms, the app dynamically adjusts prices based on demand, delivery time, and geographic hotspots. This increases profitability while ensuring competitive pricing in the U.S. market.",
    },
  ]
}

const benifitData = {
  label: "AI-ENABLED Benefits In",
  headingPart1: "Encounter",
  headingPart2: "The Advantages of",
  headingPart3: "our DoorDash Clone App",
  subHeading: "Mobility Infotech’s AI features empower your platform to be faster, smarter, and more personalized—driving growth and giving you an edge in the U.S. food delivery landscape.",
  allTabs: [
    {
      name: "Eater",
      data: [
        {
          image: "/assets/home/uber-eats-eater-1.webp",
          mainImage: "/assets/home/uber-eats-eater-main1.webp",
          title: "Takeaway Option",
          desc: "AI recommends optimal pickup times and preferred dishes for quicker takeout orders.",
        },
        {
          image: "/assets/home/uber-eats-eater-2.webp",
          mainImage: "/assets/home/uber-eats-eater-main2.webp",
          title: "Support Option",
          desc: "Real-time, AI-driven customer support resolves queries instantly.",
        },
        {
          image: "/assets/home/uber-eats-eater-3.webp",
          mainImage: "/assets/home/uber-eats-eater-main3.webp",
          title: "Tips Option",
          desc: "AI suggests fair and personalized tip amounts based on order history.",
        },
        {
          image: "/assets/home/uber-eats-eater-4.webp",
          mainImage: "/assets/home/uber-eats-eater-main4.webp",
          title: "Payment Gateway",
          desc: "Transactions remain safe and smooth with AI detecting suspicious activities.",
        },
        {
          image: "/assets/home/uber-eats-eater-5.webp",
          mainImage: "/assets/home/uber-eats-eater-main5.webp",
          title: "Profile Management",
          desc: "AI stores preferences, dietary requests, and history for a consistent user experience.",
        },
      ],
    },
    {
      name: "restaurant Owner",
      data: [
        {
          image: "/assets/home/uber-eats-eater-1.webp",
          mainImage: "/assets/home/uber-eats-restaurant-main1.webp",
          title: "Takeaway Option",
          desc: "Boost sales with AI-backed recommendations for trending menu items and pricing strategies.",
        },
        {
          image: "/assets/home/uber-eats-eater-2.webp",
          mainImage: "/assets/home/uber-eats-restaurant-main2.webp",
          title: "Profile Management",
          desc: "AI helps refine menus by analyzing reviews, customer behavior, and local demand.",
        },
        {
          image: "/assets/home/uber-eats-eater-3.webp",
          mainImage: "/assets/home/uber-eats-restaurant-main3.webp",
          title: "Multiple Language",
          desc: "AI translation enables restaurant menus to reach multilingual U.S. audiences effortlessly.",
        },
      ],
    },
    {
      name: "DELIVERY PROVIDER",
      data: [
        {
          image: "/assets/home/uber-eats-eater-1.webp",
          mainImage: "/assets/home/uber-eats-delivery-main1.webp",
          title: "Single Pickup/Multiple Delivery Option",
          desc: "AI clusters orders efficiently, saving fuel and boosting speed.",
        },
        {
          image: "/assets/home/uber-eats-eater-2.webp",
          mainImage: "/assets/home/uber-eats-delivery-main2.webp",
          title: "Tips Option",
          desc: "AI-generated suggestions encourage higher, fairer tips.",
        },
        {
          image: "/assets/home/uber-eats-eater-3.webp",
          mainImage: "/assets/home/uber-eats-delivery-main3.webp",
          title: "Profile Management",
          desc: "Performance, earnings, and ratings are tracked intelligently to improve driver efficiency.",
        },
        {
          image: "/assets/home/uber-eats-eater-4.webp",
          mainImage: "/assets/home/uber-eats-delivery-main4.webp",
          title: "Multiple Language",
          desc: "Drivers can interact seamlessly with users across diverse U.S. regions.",
        },
        {
          image: "/assets/home/uber-eats-eater-5.webp",
          mainImage: "/assets/home/uber-eats-delivery-main5.webp",
          title: "Navigation Option",
          desc: "AI ensures real-time optimized routing for faster deliveries.",
        },
      ],
    },
    {
      name: "ADMIN",
      data: [
        {
          image: "/assets/home/uber-eats-eater-1.webp",
          mainImage: "/assets/home/uber-eats-admin-main1.webp",
          title: "Separate Eaters, Drivers, Restaurant Management",
          desc: "AI makes it simple to manage multiple user categories clearly and effectively.",
        },
        {
          image: "/assets/home/uber-eats-eater-2.webp",
          mainImage: "/assets/home/uber-eats-admin-main2.webp",
          title: "Single Pickup/Multiple Delivery Option",
          desc: "AI optimizes logistics for bulk orders and grouped deliveries.",
        },
        {
          image: "/assets/home/uber-eats-eater-3.webp",
          mainImage: "/assets/home/uber-eats-admin-main3.webp",
          title: "Support Option",
          desc: "AI-powered chat support provides immediate assistance for smoother operations.",
        },
        {
          image: "/assets/home/uber-eats-eater-4.webp",
          mainImage: "/assets/home/uber-eats-admin-main4.webp",
          title: "Admin Management & Roles",
          desc: "Assign roles and manage permissions intelligently with AI insights.",
        },
        {
          image: "/assets/home/uber-eats-eater-5.webp",
          mainImage: "/assets/home/uber-eats-admin-main5.webp",
          title: "Easy Driver Document Management",
          desc: "AI validates driver documents quickly for compliance and hassle-free onboarding.",
        },
      ],
    }
  ]

}

const stepData = {
  headingPart1: "Step-By-Step Order Flow",
  headingPart2: "In A DoorDash Clone App",
  subHeading: "Explore the complete order flow of a DoorDash clone app, from browsing restaurants to doorstep delivery.",
  image: "",
}

const forYouData = {
  newClass: "uber-eats-for-you",
  text1: "$50 Billion+ Market",
  text2: "Opportunity",
  des: "On-demand grocery delivery apps are rapidly capturing global market share and consumer demand.",
  btn: "Build Your App",
}

const scriptData = {
  titlePart1: "Best",
  titlePart2: "Food Delivery Scripts",
  titlePart3: "to Launch Your On-Demand App",
  description: "Launch your own food delivery business with these top-rated food delivery scripts inspired by global brands.",
}

const demandData = {
  image: "/assets/home/uber-eats-demand.webp",
  titlePart1: "Lead the",
  titlePart2: "On-Demand Food",
  titlePart3: "Delivery World",
  desc: "The U.S. food delivery market is expanding rapidly. With the DoorDash Clone Script by Mobility Infotech, you gain a proven, customizable, and scalable solution that allows you to launch fast, compete effectively, and grow consistently. Enjoy robust features, geo-based listings, multi-payment integrations, and real-time order tracking for a premium user experience.",
  desc2: "",
  cta: "Schedule a meeting"
}

const RevenueData = {
  titlePart1: "How",
  titlePart2: "DoorDash Clone Apps",
  titlePart3: "Are Making Revenue?",
  desc: "Ultimate Earning Sources Of Our DoorDash Clone Script",
  boxes: [
    {
      image: "/assets/home/eats-revenue-1.webp",
      heading: "Commission Fee",
      description: "Earn service fees on every transaction from both customers and restaurants.",
    },
    {
      image: "/assets/home/eats-revenue-2.webp",
      heading: "Dynamic Surge Pricing",
      description: "AI-driven surge pricing maximizes revenue during peak demand.",
    },
    {
      image: "/assets/home/eats-revenue-3.webp",
      heading: "Referral Earnings",
      description: "Boost user growth with referral bonuses that turn customers into brand advocates.",
    },
    {
      image: "/assets/home/eats-revenue-4.webp",
      heading: "Showcase The Sponsors",
      description: "Offer premium listing opportunities for restaurants to increase visibility.",
    },
    {
      image: "/assets/home/eats-revenue-5.webp",
      heading: "Flexible Commissions",
      description: "Set commissions dynamically based on order volumes or restaurant popularity.",
    },
  ]
}

const uniqueData = {
  titlePart1: "What Makes Us",
  titlePart2: "Unique?",
  desc: "Why choose Mobility Infotech’s DoorDash Clone Script for the USA? Because we deliver unmatched support, flexibility, and value.",
  boxes: [
    {
      image: "/assets/home/uber-eats-unique-1.webp",
      heading: "Free Server Installation",
      description: "Quick deployment on your server.",
    },
    {
      image: "/assets/home/uber-eats-unique-2.webp",
      heading: "Free App Submission",
      description: "Full support for App & Play Stores.",
    },
    {
      image: "/assets/home/uber-eats-unique-1.webp",
      heading: "Free Bug Support",
      description: "Fast fixes during support period.",
    },
    {
      image: "/assets/home/uber-eats-unique-4.webp",
      heading: "On-Time Support",
      description: "Multichannel help when needed.",
    },
    {
      image: "/assets/home/uber-eats-unique-5.webp",
      heading: "100% Source Code",
      description: "Scale & customize with control.",
    },
    {
      image: "/assets/home/uber-eats-unique-6.webp",
      heading: "Native IOS & Android Apps",
      description: "High performance on both apps.",
    },
    {
      image: "/assets/home/uber-eats-unique-7.webp",
      heading: "Support After App Rejection",
      description: "Help to get approval quickly.",
    },
    {
      image: "/assets/home/uber-eats-unique-8.webp",
      heading: "Free Technical Support",
      description: "Payments, SMS, servers & more.",
    },
    {
      image: "/assets/home/uber-eats-unique-9.webp",
      heading: "Free White Labeling",
      description: "Replace branding seamlessly.",
    },
  ]
}

const loveData = {
  titlePart1: "Unique Features",
  titlePart2: "You’ll Love",
  desc: "Explore the powerful, user-focused features that make the Mobility Infotech platform stand out. Designed for performance, scalability, and ease of use, each function is built to elevate your food delivery business.",
  boxes: [
    {
      image: "/assets/home/uber-eats-love-1.webp",
      heading: "Admin Management & Roles",
      description: "Full control over workflows.",
    },
    {
      image: "/assets/home/uber-eats-love-2.webp",
      heading: "Unique Dashboards",
      description: "Separate dashboards for each user type.",
    },
    {
      image: "/assets/home/uber-eats-love-3.webp",
      heading: "Easy Driver Documentation",
      description: "Quick, AI-backed driver verification.",
    },
    {
      image: "/assets/home/uber-eats-love-4.webp",
      heading: "Live Tracking",
      description: "GPS-powered delivery tracking in real time.",
    },
    {
      image: "/assets/home/uber-eats-love-5.webp",
      heading: "Review Management",
      description: "Monitor, edit, and manage reviews.",
    },
    {
      image: "/assets/home/uber-eats-love-6.webp",
      heading: "Reports",
      description: "Exportable analytics for growth planning.",
    },
    {
      image: "/assets/home/uber-eats-love-7.webp",
      heading: "Geo-Location Search",
      description: "Accurate restaurant and delivery tracking.",
    },
    {
      image: "/assets/home/uber-eats-love-8.webp",
      heading: "Real-Time Currency Rates",
      description: "Perfect for cross-border expansion.",
    },
    {
      image: "/assets/home/uber-eats-love-9.webp",
      heading: "Quick Business Launch",
      description: "Deploy your app fast with pre-built solutions.",
    },
  ]
}

const forYouTwoData = {
  newClass: "uber-eats-for-you-two",
  text1: "Leaders in Food",
  text2: "Delivery Innovation",
  des: "Innovative food delivery solutions designed for seamless experiences, business growth, and long-term market success.",
  btn: "Build Your App",
}

const powerData = {
  titlePart1: "Power Up with",
  titlePart2: "Add-Ons",
  desc: "Expand capabilities and revenue streams with advanced add-ons:",
  boxes: [
    {
      image: "/assets/home/uber-eats-power-1.webp",
      heading: "Multiple Language",
      description: "Reach diverse audiences across the U.S.",
    },
    {
      image: "/assets/home/uber-eats-power-2.webp",
      heading: "RTL Support",
      description: "Expand into Middle Eastern/U.S. Arabic-speaking communities.",
    },
    {
      image: "/assets/home/uber-eats-power-3.webp",
      heading: "Modifiers",
      description: "Give restaurants flexibility to customize menus.",
    },
    {
      image: "/assets/home/uber-eats-power-4.webp",
      heading: "ChatGPT",
      description: "AI-driven customer support automation.",
    },
    {
      image: "/assets/home/uber-eats-power-5.webp",
      heading: "Algolia Search",
      description: "Faster, smarter search results always.",
    },
    {
      image: "/assets/home/uber-eats-power-6.webp",
      heading: "Crypto Wallet",
      description: "Accept modern digital payments securely.",
    },
    {
      image: "/assets/home/uber-eats-power-7.webp",
      heading: "Kiosk",
      description: "Streamline in-store orders for customers.",
    },
    {
      image: "/assets/home/uber-eats-power-8.webp",
      heading: "Sunmi Integration",
      description: "Simplify receipt printing and management.",
    },
    {
      image: "/assets/home/uber-eats-power-9.webp",
      heading: "Local Pay Gateway",
      description: "Support U.S.-specific payment providers.",
    },
    {
      image: "/assets/home/uber-eats-power-10.webp",
      heading: "Other Maps",
      description: "Use Mapbox or TomTom as alternatives.",
    },
    {
      image: "/assets/home/uber-eats-power-11.webp",
      heading: "Local SMS Gateway",
      description: "Enhance account security with local SMS verification.",
    },
    {
      image: "/assets/home/uber-eats-power-12.webp",
      heading: "External DB Backup",
      description: "Secure and safe database backups for protection.",
    },
    {
      image: "/assets/home/uber-eats-power-13.webp",
      heading: "Driver Subscription",
      description: "Flexible commission alternatives for loyalty.",
    },
    {
      image: "/assets/home/uber-eats-power-14.webp",
      heading: "Driver Wallet",
      description: "In-app wallet for drivers’ earnings.",
    },
    {
      image: "/assets/home/uber-eats-power-15.webp",
      heading: "Store own driver",
      description: "Allow restaurants to manage their own delivery staff.",
    },
    {
      image: "/assets/home/uber-eats-power-16.webp",
      heading: "Bidding System",
      description: "Let delivery drivers bid on orders for fair pricing.",
    },
  ]
}

const advanceData = {
  titlePart1: "Advance",
  titlePart2: "Add-Ons",
  desc: "Enhance your food delivery business with AI-powered advanced features:",
  boxes: [
    {
      image: "/assets/home/uber-eats-advance-1.webp",
      backImage: "/assets/home/uber-eats-advance-back1.webp",
      heading: "ChatBots",
      description: "Smart & AI-Driven automated query handling.",
    },
    {
      image: "/assets/home/uber-eats-advance-2.webp",
      backImage: "/assets/home/uber-eats-advance-back2.webp",
      heading: "Push Alerts",
      description: "Personalized notifications for engagement.",
    },
    {
      image: "/assets/home/uber-eats-advance-3.webp",
      backImage: "/assets/home/uber-eats-advance-back3.webp",
      heading: "Optimised Bookings",
      description: "Predictive demand insights for peak hours.",
    },
  ]
}

const offerData = {
  label: "Our Offerings",
  headingPart1: "What Do",
  headingPart2: "We Offer?",
  headingPart3: "",
  subHeading: "At Mobility Infotech, we deliver robust, easy-to-use user panels built to simplify operations, elevate the customer experience, and centralize management for diners, restaurants, and delivery partners — all inside one unified ecosystem for your DoorDash Clone App.",
  allTabs: [
    {
      name: "Eaters",
      boxes: [
        {
          image: "/assets/home/uber-eats-offer-1.webp",
          heading: "Eaters Android",
          description: "Lets customers discover nearby restaurants and dishes, place orders, save favourites, and manage their profiles effortlessly from Android devices.",
        },
        {
          image: "/assets/home/uber-eats-offer-2.webp",
          heading: "Eaters  iOS",
          description: "The iOS counterpart that enables diners to browse restaurants, reorder favourites, store preferences, and view order history in an elegant interface.",
        },
        {
          image: "/assets/home/uber-eats-offer-3.webp",
          heading: "Eaters Web panel",
          description: "A user-friendly web panel where customers can search restaurants and dishes, place orders, manage their profiles, and track past activity from any browser.",
        },
      ]
    },
    {
      name: "restaurant",
      boxes: [
        {
          image: "/assets/home/uber-eats-offer-1.webp",
          heading: "Restaurant Owner Android",
          description: "A dedicated Android app for restaurant owners to manage orders, update menus, accept pickups, and handle operations quickly and reliably.",
        },
        {
          image: "/assets/home/uber-eats-offer-2.webp",
          heading: "Restaurant Owner  iOS",
          description: "A polished iOS app that streamlines order management, menu edits, promotions, and real-time communication with customers and drivers.",
        },
        {
          image: "/assets/home/uber-eats-offer-3.webp",
          heading: "Restaurant Owner Web panel",
          description: "A comprehensive web dashboard to manage menus, monitor incoming orders, track sales, and review earnings with clarity and complete control.",
        },
      ]
    },
    {
      name: "provider",
      boxes: [
        {
          image: "/assets/home/uber-eats-offer-1.webp",
          heading: "provider Android",
          description: "A purpose-built Android app for delivery partners to receive jobs, navigate routes, update delivery status, and complete orders efficiently.",
        },
        {
          image: "/assets/home/uber-eats-offer-2.webp",
          heading: "provider  iOS",
          description: "An intuitive iOS app for delivery partners that provides turn-by-turn navigation, earnings summary, and easy order acceptance and tracking.",
        },
        {
          image: "/assets/home/uber-eats-offer-3.webp",
          heading: "provider Web panel",
          description: "A simple, effective web portal for delivery partners to view assigned trips, check earnings, manage availability, and track completed deliveries.",
        },
      ]
    },
    {
      name: "Admin",
      boxes: [
        {
          image: "/assets/home/uber-eats-offer-3.webp",
          heading: "Admin Web panel",
          description: "A powerful admin dashboard that enables platform administrators to manage users, supervise operations, monitor revenue, generate reports, and ensure smooth, secure performance across the entire DoorDash Clone ecosystem.",
        },
      ]
    },

  ]
}

const faqData = [
  {
    id: "0",
    question: "01. What is a DoorDash Clone app by Mobility Infotech?",
    answer: "A ready-to-launch food delivery platform mirroring DoorDash’s features, customizable for U.S. businesses.",
  },
  {
    id: "1",
    question: "02. How long does it take to launch?",
    answer: "Just days—with free server setup, app submission, and white labeling included.",
  },
  {
    id: "2",
    question: "03. Is it customizable? ",
    answer: "Yes—modify design, branding, features, and integrations to suit your U.S. market.",
  },
  {
    id: "3",
    question: "04. How does AI help?",
    answer: "AI enhances delivery speed, pricing, recommendations, customer support, and analytics.",
  },
  {
    id: "4",
    question: "05. Do I get source code?",
    answer: "Yes—100% source code access, depending on your package.",
  },
  {
    id: "5",
    question: "06. What platforms are supported?",
    answer: "Native iOS, Android apps, and robust web panels for restaurants, drivers, and admins.",
  },

  {
    id: "6",
    question: "07. How does the revenue model work? ",
    answer: "Earn via commissions, surge pricing, referrals, premium listings, and flexible fees.",
  },
];

export default function DoordashClone() {
  return (
    <>
      <UberEatsBanner data={bannerData} />
      <UberEatsHelp data={helpData} />

      <Suspense fallback={null}>
        <UberEatsProcess data={processData} />
        <UberEatsBenifits data={benifitData} />
        <UberEatsSteps data={stepData} />
        <GroceryMarket data={forYouData} />
        <UberEatsScript data={scriptData} />
        <UberEatsDemand data={demandData} />
        <UberEatsRevenue data={RevenueData} />
        <UberEatsUnique data={uniqueData} />
        <UberEatsLove data={loveData} />
        <GroceryMarket data={forYouTwoData} />
        <UberEatsPower data={powerData} />
        <UberEatsAdvance data={advanceData} />
        <UberEatsOffer data={offerData} />
        <ShuttleAppreciation />
        <div className="zip-faq-fixer">
          <TaxiFaq faqData={faqData} />
        </div>
      </Suspense>
    </>
  )
}
